import { motion } from "framer-motion"
import React, { useState } from "react"

import useTestimonials from "../../../hooks/useTestimonials"
import { useTranslation } from "../../../i18n/translate"
import ArrowLeftIcon from "../../../images/icons/arrow_left.svg"
import ArrowRightIcon from "../../../images/icons/arrow_right.svg"
import CalendarIcon from "../../../images/icons/calendar.svg"
import JobPositionIcon from "../../../images/icons/job_position.svg"
import LocationIcon from "../../../images/icons/location.svg"
import SegmentIcon from "../../../images/icons/segment.svg"
import FadeTransitionText from "../../fade-transition-text/fade-transition-text"
import IconInformation from "../../icon-information/icon-information"
import Tile from "../../tile/tile"
import "./testimonials.sass"

const Testimonials = ({}) => {
  const { t } = useTranslation()

  const testimonials = useTestimonials()

  const [activeIndex, setActiveIndex] = useState(0)

  const setIndex = (newIndex) => {
    setActiveIndex((newIndex + testimonials.length) % testimonials.length)
  }

  return (
    <motion.div layout>
      <div className="_fp-testimonial">
        <Tile>
          <div className={"_fp-testimonial__title"}>
            <h3 className={"_fp-heading-1"}>
              {t("CAREER-TESTIMONIALS-TITLE")}
            </h3>
          </div>

          <div className={"_fp-testimonials"}>
            <div className={"_fp-testimonials__image"}>
              <motion.img
                src={
                  testimonials[activeIndex].image?.image?.localFile?.publicURL
                }
                alt={t(testimonials[activeIndex].description?.key)}
              />
            </div>

            <div className="_fp-testimonials__info">
              <h3 className={"_fp-heading-2 _fp-testimonials__info__heading"}>
                <FadeTransitionText
                  activeIndex={activeIndex}
                  texts={testimonials.map((t) => t.name)}
                />
              </h3>

              <div className="_fp-testimonials__info__icon-grid">
                <IconInformation
                  iconComponent={<LocationIcon />}
                  title={t("CAREER-TESTIMONIALS-LOCATION")}
                >
                  <FadeTransitionText
                    activeIndex={activeIndex}
                    texts={testimonials.map((testimonial) =>
                      t(testimonial.location?.key),
                    )}
                  />
                </IconInformation>
                <IconInformation
                  iconComponent={<CalendarIcon />}
                  title={t("CAREER-TESTIMONIALS-AT_MUNZING_SINCE")}
                >
                  <FadeTransitionText
                    activeIndex={activeIndex}
                    texts={testimonials.map((testimonial) =>
                      testimonial.atMunzingSince?.getFullYear().toString(),
                    )}
                  />
                </IconInformation>

                <IconInformation
                  iconComponent={<SegmentIcon />}
                  title={t("CAREER-TESTIMONIALS-DEPARTMENT")}
                >
                  <FadeTransitionText
                    activeIndex={activeIndex}
                    texts={testimonials.map((testimonial) =>
                      t(testimonial.segment?.key),
                    )}
                  />
                </IconInformation>

                <IconInformation
                  iconComponent={<JobPositionIcon />}
                  title={t("CAREER-TESTIMONIALS-POSITION")}
                >
                  <FadeTransitionText
                    activeIndex={activeIndex}
                    texts={testimonials.map((testimonial) =>
                      t(testimonial.position?.key),
                    )}
                  />
                </IconInformation>
              </div>
            </div>

            <span className={"_fp-text _fp-testimonials__text"}>
              <FadeTransitionText
                activeIndex={activeIndex}
                texts={testimonials.map((testimonial) =>
                  t(testimonial.description?.key),
                )}
              />
            </span>

            {testimonials.length > 1 && (
              <div className="_fp-testimonials__page-indicator">
                <button
                  aria-label={t("CAREER-TESTIMONIALS-PREVIOUS_TESTIMONIAL")}
                  type={"button"}
                  id={"prevTestimonial"}
                  onClick={() => setIndex(activeIndex - 1)}
                >
                  <ArrowLeftIcon />
                </button>
                <span>
                  {activeIndex + 1}/{testimonials.length}
                </span>
                <button
                  aria-label={t("CAREER-TESTIMONIALS-NEXT_TESTIMONIAL")}
                  type={"button"}
                  id={"nextTestimonial"}
                  onClick={() => setIndex(activeIndex + 1)}
                >
                  <ArrowRightIcon />
                </button>
              </div>
            )}
          </div>
        </Tile>
      </div>
    </motion.div>
  )
}

export default Testimonials
